import {
    scrollTo
} from './_scrollTo';

var validateCardInfo = () => {
	
	if($('#payment-info-create').length > 0){
		$('#payment-info-create').on('click', function(){
			if($('#payment-info-add-card-number').val() != ''){
				if(!validateCardNumber('#payment-info-add-card-number')){
					displayDynamicCCalert('This card number is invalid.','danger');
					Dillards.doScrollToTop();
					return false;
				}
			}
		});
	}
	
	if($('#order-review-button').length > 0){
		
		$('#cardNumber, #savedCard').on('change', function(){
			$('#generic-error-message').remove();
			$('#cardNumber').parents('.form-group').removeClass('has-error');
		});
		
		$('#generic-error-message').remove();
		$('#cardNumber').parents('.form-group').removeClass('has-error');
		if($('#newCard').prop('checked') && $('#cardNumber').val() != ''){
			if(!validateCardNumber('#cardNumber')){
				$('#messages').append('<div data-twist="generic-error" id="generic-error-message" class="alert alert-danger" role="alert" aria-live="assertive"><div class="generic-error-display-message">This card number is invalid.</div></div>');
				$('#cardNumber').parents('.form-group').addClass('has-error');
				scrollTo('#paymentWrapper #messages');
				$('html,body').stop(true,true).animate({scrollTop: $('#generic-error-message').offset().top - 20}, 'slow');
				return false;
			}
		}
		return true;
	}
};

var validateCardNumber = (id) => {
	var cardIsValid = true;
	var cardnum = $(id).val();
	var doCardCheck = $(id).data('ccCheck');
	
	if(doCardCheck && (!validPrefixAndLgth(cardnum) || !passedLuhnCheck(cardnum))){
		cardIsValid = false;
	}
	
	return cardIsValid;
}

var validPrefixAndLgth = (value) => {
	var accepted = false;
	var validCC ={
			amex: 			/^3[47][0-9]{13}$/,
			dillards:		/^579674[0-9]{10}|604587[0-9]{10}|603537[0-9]{10}$/,
			dillardsPL:		/^603537[0-9]{10}$/,
			dillardsMC:		/^519457[0-9]{10}$/,
			discover: 		/^(?:3(0[0-5][0-9]{11}(?:[0-9]{2})?|0[8][89][0-9]{10}(?:[0-9]{2})?|09[0-9]{11}(?:[0-9]{2})?|1[0-2][0-9][0-9]{10}(?:[0-9]{2})?|15[89][0-9]{10}(?:[0-9]{2})?|[3568][02-8][0-9]{11}(?:[0-9]{2})?)|6(011[02349][0-9]{9}(?:[0-9]{2})?|011[78][46789][0-9]{8}(?:[0-9]{2})?|5[0-9]{12}(?:[0-9]{2})?|[24][456][0-9]{11}(?:[0-9]{2})?|2[28][2-9][0-9]{10}(?:[0-9]{2})?|22(1[3-9]|9[01])[0-9]{9}(?:[0-9]{2})?|22(12[6-9]|92[0-5])[0-9]{8}(?:[0-9]{2})?)|81([0-6][0-9]{11}(?:[0-9]{2})?|7[01][0-9]{10(?:[0-9]{2})?}))$/,
			mastercard:		/^(?:2[2-7][0-9]{12}(?:[0-9]{2})?|5[1-5][0-9]{12}(?:[0-9]{2})?)$/,
			visa:			/^4[0-9]{12}(?:[0-9]{3})?$/
	};
	
	Object.keys(validCC).forEach(function(key) {
		var regex = validCC[key];
		if (regex.test(value)) {
			accepted = true;
		}
	});
  return accepted;
}

var passedLuhnCheck = (value) => {
	
	value.replace(/\D/g, '');
	var sum = 0;
	var shouldDouble = false;
	
	for (var i = value.length - 1; i >= 0; i--) {
		var digit = parseInt(value.charAt(i));
		
		if (shouldDouble && (digit *= 2) > 9) digit -= 9;
		
		sum += digit;
		shouldDouble = !shouldDouble;
	}
	return (sum %10) == 0;
}

export {
	validateCardInfo
}
